(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lc-studio-shell"] && !Shopify.designMode) return;
  try {
    (() => {
  const desktopFooter = window.matchMedia('(min-width: 750px)');
  function init() {
    if (!document.querySelector('.lcp-header')) return;
    document.querySelectorAll('.lcpf-column').forEach((column) => {
      if (column.dataset.lcsReady) return;
      const title = column.querySelector('h2'), nav = column.querySelector('nav');
      if (!title || !nav) return;
      const details = document.createElement('details'), summary = document.createElement('summary');
      details.className = 'lcs-footer-details';
      details.open = desktopFooter.matches;
      summary.append(title); details.append(summary, nav); column.append(details);
      column.dataset.lcsReady = 'true';
      summary.addEventListener('click', (event) => { if (desktopFooter.matches) event.preventDefault(); });
    });
    const drawer = document.querySelector('[data-lcp-drawer]');
    if (drawer && !drawer.dataset.lcsFocusReady) {
      const panel = drawer.querySelector('.lcp-drawer__panel');
      if (panel) {
        drawer.dataset.lcsFocusReady = 'true';
        let previousFocus = null, wasOpen = false;
        const focusable = () => Array.from(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary,[tabindex="0"]')).filter(el => el.getClientRects().length);
        new MutationObserver(() => {
          const open = drawer.classList.contains('is-open');
          if (open && !wasOpen) {
            previousFocus = document.activeElement;
            requestAnimationFrame(() => (panel.querySelector('[data-lcp-close]') || focusable()[0])?.focus());
          } else if (!open && wasOpen && previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
          wasOpen = open;
        }).observe(drawer, {attributes:true, attributeFilter:['class']});
        drawer.addEventListener('keydown', event => {
          if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
          const items = focusable(); if (!items.length) return;
          const first = items[0], last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        });
      }
    }
    document.querySelectorAll('.lcp-navitem').forEach(item => {
      if (item.dataset.lcsMenuReady) return;
      item.dataset.lcsMenuReady = 'true';
      item.addEventListener('mouseenter', () => item.classList.remove('lcs-menu-dismissed'));
      item.addEventListener('focusout', event => { if (!item.contains(event.relatedTarget)) item.classList.remove('lcs-menu-dismissed'); });
      item.addEventListener('keydown', event => {
        if (event.key === 'Escape') { item.classList.add('lcs-menu-dismissed'); item.querySelector('.lcp-navlink')?.focus(); }
        else if (event.key === 'ArrowDown' && event.target.matches('.lcp-navlink')) {
          item.classList.remove('lcs-menu-dismissed');
          const first = item.querySelector('.lcp-mega a');
          if (first) { event.preventDefault(); first.focus(); }
        }
      });
    });
    document.querySelectorAll('.lcq__row').forEach(row => {
      if (row.dataset.lcsPositioned) return;
      row.dataset.lcsPositioned = 'true';
      const active = row.querySelector('[aria-current="page"],.is-active');
      if (active && row.scrollWidth > row.clientWidth) {
        row.scrollLeft = Math.max(0, active.offsetLeft - row.offsetLeft - (row.clientWidth - active.clientWidth) / 2);
      }
    });
  }
  desktopFooter.addEventListener('change', () => document.querySelectorAll('.lcs-footer-details').forEach(details => { details.open = desktopFooter.matches; }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
